import _ from 'lodash';
import * as React from 'react';
import styled from 'styled-components';

import theme from '../../easyclaim.app.theme/theme';

import { Circle } from './Circle';

interface DotsProps {
	range: number;
	active?: number;
	onClick?: (index: number) => void;
}

interface DotsState {}

export class Dots extends React.Component<DotsProps, DotsState> {
	constructor(props: DotsProps) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<Container>
				{_.range(0, this.props.range).map((i) => (
					<Circle
						key={i}
						size=".5rem"
						backgroundColor={i + 1 === this.props.active ? theme.colors.secondary : undefined}
						borderColor={theme.colors.secondary}
						borderStyle="solid"
						borderWidth="1px"
						onClick={() => this.props.onClick && this.props.onClick(i + 1)}
					/>
				))}
			</Container>
		);
	}
}

const Container = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	& > {
		flex-shrink: 0;
	}
	& > :not(:last-child) {
		margin-right: 0.8rem;
	}
`;
